import { ThunkAction } from "redux-thunk";
import { Action } from "redux";
import { ILoginState } from "src/store/login";
import { INotesRootState } from "src/store/takeNotes";
import { IHomeReducerState } from "src/store/home";
import { CategoryReducerState } from "src/store/category";
import { DetailsReducerState } from "src/store/details";
import { AppState } from "src/store/app";

export interface IKeyValueType {
  value: string;
  displayName: string;
  hintText?: string;
}

export type ApiResponse = Promise<{
  response: any;
  error: any;
}>;

export interface IRootState {
  category: CategoryReducerState;
  notes: INotesRootState;
  home: IHomeReducerState;
  metricDetails: DetailsReducerState;
  login: ILoginState;
  app: AppState;
}

export type ThunkResult<T> = ThunkAction<T, IRootState, unknown, Action<string | symbol>>;

export interface ISinglePin {
  id: number;
  metricId?: number;
  label: string;
  filters: { [key: string]: string[] }[];
  performanceChartIds: number[];
  currentChart: {
    lastUpdatedTimeStamp: number;
  };
  pastChart: number;
  notes: [
    {
      text: string;
      updatedAt: string;
    }
  ];
  bigNumber: string;
  vCompare: string;
  progress?: boolean;
  successful?: boolean;
  isPercentage: boolean;
  isAnomalous: 0 | 1 | 2;
  isPositive: boolean;
  lowerBound: number;
  upperBound: number;
  owner: string;
  dataset: string;
  freshness: number;
  sla: number;
  time_stamp: string;
  isHidden: string;
  message: string;
  unit: string;
}

export enum SearchTarget {
  HOME = "HOME",
  ALLORGMETRICS = "ALLORGMETRICS",
}

export enum FilterUsedBy {
  ORG = "org",
  PINS = "pins",
  ALL = "all",
  DETAILS = "details",
}

export enum IconClass {
  SEARCH = "search",
  SLIDERS = "sliders",
  SYNC = "sync",
  COMPARE = "chart-compare",
  PUSHPIN = "pushpin",
  Home = "home",
}

export enum JoyrideState {
  MANAGE_METRICS = "MANAGE_METRICS",
  TAKE_NOTES = "TAKE_NOTES",
  HOME = "HOME",
  CATEGORY = "CATEGORY",
  SEARCH = "SEARCH",
  ALLORGMETRICS = "ALLORGMETRICS",
  DETAILS = "DETAILS",
}

export enum TimeTabs {
  TODAY = "Today",
  YESTERDAY = "Yesterday",
  THIS_WEEK = "Last 7 days",
  THIS_MONTH = "Last 4 weeks",
}

export type trendlineData = { x: number; y: number; formatted: string }[];

export enum NotificationType {
  INFO = "info",
  SUCCESS = "success",
  ERROR = "error",
}
